import { render, staticRenderFns } from "./otp-modal.vue?vue&type=template&id=326e72d8&scoped=true"
import script from "./otp-modal.ts?vue&type=script&lang=ts&external"
export * from "./otp-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./otp-modal.scss?vue&type=style&index=0&id=326e72d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e72d8",
  null
  
)

export default component.exports